import { API, API_POST } from "../../Config";

export const handleAddVoucher = (payload) => {
  const f = new FormData();
  console.log(payload);
  f.append("name", payload.name);
  f.append("description", payload.description);
  f.append("link", payload.link);
  f.append("code", payload.code);
  f.append("image", payload.image);
  f.append("discount_type", payload.discount_type);
  f.append("discount_value", payload.discount_value);
  f.append("voucher_type", payload.voucher_type);

  return API_POST(API.AddVoucher, f);
};
